module.exports = __webpack_public_path__ + "static/media/ringing.4df2aee7.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/sounds/ringing.mp3
// module id = 463
// module chunks = 9